import { useTranslation } from "react-i18next";
import { Globe } from "lucide-react";
import { cn } from "../utils/cn";
import { normalizeLanguage } from "../i18n";

export function LanguageSwitcher() {
  const { i18n, t } = useTranslation();
  const currentLanguage = normalizeLanguage(
    i18n.resolvedLanguage ?? i18n.language,
  );
  const nextLanguage = currentLanguage === "en" ? "zh" : "en";

  const toggleLanguage = async () => {
    await i18n.changeLanguage(nextLanguage);
  };

  const isEnglish = currentLanguage === "en";

  return (
    <button
      onClick={toggleLanguage}
      className={cn(
        "flex items-center gap-1.5 px-2.5 py-1.5 rounded-lg transition-all",
        "bg-gradient-to-r from-gray-50 to-gray-100 border border-gray-200",
        "hover:from-gray-100 hover:to-gray-150 hover:border-gray-300",
        "text-xs font-medium text-gray-600",
      )}
      title={t("language.switchTo")}
      aria-label={t("language.switchLabel")}
    >
      <Globe className="w-3.5 h-3.5" />
      <span>{isEnglish ? "中文" : "EN"}</span>
    </button>
  );
}
